import { useQuery } from '@tanstack/react-query';
import { sfiBackendSvc } from 'api/DashboardAPI';
import { QueryKey } from 'utils/constants/query-keys.enum';
import { QueryOptions } from 'utils/useQueryUtils';

interface UseDashboardInfoParams extends QueryOptions {
  walletAddress: string;
}
export const useDashboardInfo = (options: UseDashboardInfoParams) => {
  const { walletAddress, query } = options || {};
  const useQueryOptions = {
    queryKey: [QueryKey.DASHBOARD_LIST, walletAddress],
    ...query,
  };

  return useQuery({
    queryFn: () =>
      sfiBackendSvc.getDashboardDetails({
        walletAddress,
      }),
    enabled: true,
    ...useQueryOptions,
  });
};
